import { motion } from "framer-motion";
import { Shield } from "lucide-react";

const RegulatorySection = () => {
  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mx-auto max-w-4xl rounded-2xl border border-gold-dark/30 bg-card p-8 md:p-12"
        >
          <div className="flex items-center gap-3 mb-6">
            <Shield className="h-6 w-6 text-gold" />
            <h3 className="font-display text-lg font-bold text-gold">Regulatory Information</h3>
          </div>

          <div className="space-y-4 text-sm text-muted-foreground font-body leading-relaxed">
            <p>
              <span className="text-foreground font-semibold">PRIME PROFIT</span> (company code: 306377915) is authorized and regulated by the Bank of America ("BoL") as a financial earning platform.
            </p>

            <div className="border-t border-gold-dark/20 pt-4">
              <p className="text-xs text-muted-foreground/80 font-semibold uppercase tracking-wider mb-3">Company Information</p>
              <p>
                PRIME PROFIT is a brand name with multiple entities that are authorised and registered in various jurisdictions:
              </p>
            </div>

            <div className="rounded-lg bg-secondary/50 p-4 space-y-3">
              <p>
                <span className="text-foreground font-semibold">Prime Profit Ltd</span> is authorised and regulated by the Financial Services Commission under license number GB24203599, with its registered address at 6 St Denis Street, 1/F River Court, Port Louis, Mauritius.
              </p>
              <p>
                <span className="text-foreground font-semibold">Prime Systems Ltd</span>, registered address at 4B, Grigoriou Xenopoulou, 4049, Limassol, Cyprus and registration number HE462202.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default RegulatorySection;
